import React from "react";
import { Link } from "react-router-dom";

const cityToDestinationSlug = {
  "mar del plata": "mar-del-plata",
  bariloche: "bariloche",
  iguazu: "iguazu",
  "iguazu": "iguazu",
  "puerto iguazu": "iguazu",
};

const normalizeCity = (value = "") =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

const ExploreAloharLinks = ({ housing }) => {
  const cityName = housing?.location?.location || "tu destino";
  const destinationSlug = cityToDestinationSlug[normalizeCity(cityName)] || "";
  const destinationUrl = destinationSlug ? `/destinos/${destinationSlug}` : "";

  return (
    <div className="mt-6 rounded-[24px] bg-white p-6">
      <h2 className="text-2xl font-semibold text-[#111827]">Seguí explorando en Alohar</h2>
      <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        {destinationUrl ? (
          <Link
            to={destinationUrl}
            className="rounded-2xl bg-[#fff4eb] px-4 py-4 transition-colors hover:bg-[#ffe9d8]"
          >
            <p className="text-base font-medium text-[#111827]">Guía de {cityName}</p>
            <p className="mt-2 text-sm leading-6 text-[#4b5563]">
              Contexto del destino, tips y búsqueda de alojamientos.
            </p>
          </Link>
        ) : null}

        <Link
          to="/ayuda"
          className="rounded-2xl bg-[#edf6ff] px-4 py-4 transition-colors hover:bg-[#deefff]"
        >
          <p className="text-base font-medium text-[#111827]">Centro de ayuda</p>
          <p className="mt-2 text-sm leading-6 text-[#4b5563]">
            Dudas sobre reservas, pagos y funcionamiento de la plataforma.
          </p>
        </Link>

        <Link
          to="/terminos"
          className="rounded-2xl bg-[#eefaf0] px-4 py-4 transition-colors hover:bg-[#e2f6e6]"
        >
          <p className="text-base font-medium text-[#111827]">Términos</p>
          <p className="mt-2 text-sm leading-6 text-[#4b5563]">
            Condiciones del servicio, responsabilidades y marco de uso.
          </p>
        </Link>

        <Link
          to="/politica-de-privacidad"
          className="rounded-2xl bg-[#f7f0ff] px-4 py-4 transition-colors hover:bg-[#efdefe]"
        >
          <p className="text-base font-medium text-[#111827]">Privacidad</p>
          <p className="mt-2 text-sm leading-6 text-[#4b5563]">
            Cómo se utilizan los datos y qué derechos tiene cada usuario.
          </p>
        </Link>
      </div>
    </div>
  );
};

export default ExploreAloharLinks;